import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { streamSetupType } from '../../../constants/liveManagerConstants';
import { setStreamSetup } from '../../../actions/liveManagerActions';
import { ReactComponent as WirelessIcon } from '../../../assets/images/wireless_icon.svg';
import { ReactComponent as VideoCameraIcon } from '../../../assets/images/video_camera_front.svg';
import { LocalStorageService } from '../../../services/localStorageService';

import './LiveMeetingModal.scss';

interface LiveMeetingModalProps {
	open: boolean;
	onClose: () => void;
	t: (_key: string) => string;
	setStreamSetup: (_type: string) => void;
	mediaId: string;
}

const LiveMeetingModal: React.FC<LiveMeetingModalProps> = ({ open, onClose, t, setStreamSetup, mediaId }) => {
	const [selectedOption, setSelectedOption] = useState<string | null>(null);

	const handleOptionSelect = (option: string) => {
		setSelectedOption(option);
	};

	const handleConfirm = () => {
		if (selectedOption) {
			setStreamSetup(selectedOption);
			LocalStorageService.setLiveManagerSourceForMedia(mediaId, selectedOption);
		}
		onClose();
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			className="live-stream-setup-modal"
			disableBackdropClick
			disableEscapeKeyDown
		>
			<DialogTitle className="modal-header">
				{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_SELECT_LIVE_STREAM_SETUP')}
				<IconButton aria-label="close" onClick={onClose} className="close-button">
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent className="modal-content">
				<div className="stream-options">
					<div
						className={`stream-option ${selectedOption === streamSetupType.EXTERNAL ? 'selected' : ''}`}
						onClick={() => handleOptionSelect(streamSetupType.EXTERNAL)}
					>
						<div className="column">
							<div className="row">
								<div className="option-icon">
									<WirelessIcon width="20" height="18" />
								</div>
								<div className="option-title">
									{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_EXTERNAL')}
								</div>
							</div>
							<div className="option-description">
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_EXTERNAL_DESCRIPTION')}
							</div>
						</div>
					</div>

					<div
						className={`stream-option ${selectedOption === streamSetupType.MEETING ? 'selected' : ''}`}
						onClick={() => handleOptionSelect(streamSetupType.MEETING)}
					>
						<div className="column">
							<div className="row">
								<div className="option-icon">
									<VideoCameraIcon width="20" height="16" />
								</div>
								<div className="option-title">
									{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_MEETING')}
								</div>
							</div>
							<div className="option-description">
								{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_LIVE_MANAGER_MEETING_DESCRIPTION')}
							</div>
						</div>
					</div>
				</div>
			</DialogContent>
			<DialogActions className="modal-actions">
				<Button onClick={handleConfirm} variant="contained" color="primary">
					{t('COMMON_OK')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

const mapStateToProps = (state: any) => ({
	streamSetup: state.liveManager.streamSetup,
});

const mapDispatchToProps = (dispatch: any) => ({
	setStreamSetup: (streamSetup: string) => dispatch(setStreamSetup(streamSetup)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveMeetingModal);
